<div class="@container" data-test-id="usp-bar">
	<div class="flex flex-wrap @lg:flex-nowrap">
		@for (usp of uspItems(); track usp; let last = $last) {
			<div
				[ngClass]="
					cn(
						showUnionLine() ? 'px-2' : 'p-2',
						'w-full @sm:basis-1/2 @md:basis-1/3 @lg:flex-1 @lg:basis-0'
					)
				"
				data-test-class="usp"
			>
				@if (usp.link && !usp.disabled) {
					<a
						[href]="usp.link"
						[target]="usp.target ?? '_self'"
						(click)="onClick($event, usp)"
						class="flex gap-4 no-underline outline-black @lg:flex-col @lg:gap-2"
						rel="noopener noreferrer"
					>
						<ng-container
							[ngTemplateOutlet]="uspTemplate"
							[ngTemplateOutletContext]="{
								usp,
								rating: false,
								first: $first,
								last: $last && !rating()?.score,
							}"
						/>
					</a>
				} @else {
					<div class="flex gap-4 @lg:flex-col @lg:gap-2">
						<ng-container
							[ngTemplateOutlet]="uspTemplate"
							[ngTemplateOutletContext]="{
								usp,
								rating: false,
								first: $first,
								last: $last && !rating()?.score,
							}"
						/>
					</div>
				}
			</div>
		}
		@if (rating()?.score && rating()?.numberOfRatings) {
			<div
				[ngClass]="
					cn(
						showUnionLine() ? 'px-2' : 'p-2',
						'w-full @sm:basis-1/2 @md:basis-1/3 @lg:flex-1 @lg:basis-0'
					)
				"
				data-test-class="usp"
			>
				<div class="flex gap-4 @lg:flex-col @lg:gap-2">
					<ng-container
						[ngTemplateOutlet]="uspTemplate"
						[ngTemplateOutletContext]="{
							usp: {
								description: 'components.usp-bar.reviews',
								icon: rating()?.score,
								link: null,
								title:
									'components.usp-bar.ratings.' + ratingKey(),
							},
							rating: rating(),
							first: uspItems().length === 0,
							last: true,
						}"
					/>
				</div>
			</div>
		}
	</div>
</div>

<ng-template
	#uspTemplate
	let-first="first"
	let-last="last"
	let-rating="rating"
	let-usp="usp"
>
	<div class="flex shrink-0 flex-col items-center">
		@if (showUnionLine()) {
			<div
				[class.bg-accent-50]="!first"
				[class.w-px]="!first"
				class="grow"
			></div>
		}
		@if (!rating) {
			<svg-icon
				[attr.data-test-id]="usp.icon"
				[ngClass]="
					cn(
						iconVariantClass(),
						iconTypeClass(),
						iconType() !== 'shaded' &&
							iconType() !== 'solid' &&
							'icon-container-md-full @sm:icon-container-lg-full'
					)
				"
				[src]="usp.icon"
				class="icon-container shrink-0 @sm:icon-container-lg @lg:self-center"
			/>
		} @else {
			<vp-rating-svg
				[ngClass]="
					cn(
						iconVariantClass(),
						iconTypeClass(),
						iconType() !== 'shaded' &&
							iconType() !== 'solid' &&
							'icon-container-md-full @sm:icon-container-lg-full'
					)
				"
				[score]="usp.icon"
				class="icon-container shrink-0 @sm:icon-container-lg @lg:self-center"
			/>
		}
		@if (showUnionLine()) {
			<div
				[class.bg-accent-50]="!last"
				[class.w-px]="!last"
				class="grow"
			></div>
		}
	</div>
	<div
		[ngClass]="
			cn(showUnionLine() && 'py-2', 'flex items-center @lg:text-center')
		"
	>
		<div class="w-full">
			<span
				[ngClass]="
					cn(
						usp.disabled || iconVariant() === 'default'
							? 'text-dark-tertiary'
							: 'text-dark-primary'
					)
				"
				class="block font-sans-serif text-sm font-semibold @lg:text-base"
				data-test-id="usp-bar-title"
			>
				{{ usp.title | translate }}
			</span>
			<span
				[ngClass]="
					cn(
						usp.disabled || iconVariant() === 'default'
							? 'text-dark-tertiary'
							: 'text-dark-primary'
					)
				"
				class="block font-sans-serif text-sm"
				data-test-id="usp-bar-description"
			>
				{{
					usp.description
						| translate: { numberOfRatings: rating.numberOfRatings }
				}}
			</span>
		</div>
	</div>
	@if (usp.link && !usp.disabled) {
		<svg-icon
			[attr.data-test-id]="'usp-chevron'"
			class="ml-auto icon-container icon-container-sm self-center @lg:hidden"
			src="assets/icons/icon-chevron-right.svg"
		/>
	}
</ng-template>
